<template>
    <div v-show="isShow">
        <div class="login-popup">
            <a href="javascript:void(0)" class="btn-close dark" @click="close">
                <div>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80">
                        <path
                            d="M76 11.251l-7.252-7.251-28.748 28.749-28.749-28.749-7.251 7.251 28.749 28.749-28.749 28.748 7.251 7.252 28.749-28.748 28.748 28.748 7.252-7.252-28.748-28.748z">
                        </path>
                    </svg>
                </div>
            </a>
            <h1>{{ lang($t('User Login')) }}</h1>
            <p class="txt-red" v-show="showErrorMsg">{{ lang($t('Username or password is incorrect, please try again!'))
            }}</p>
            <!--box login-->
            <div class="box-login">
                <form id="loginForm" autocomplete="off">
                    <input type="text" id="username" name="username" :placeholder="lang($t('HKEP ID'))"
                        autocomplete="off" @keyup.enter="fireLogin">
                    <input type="password" id="password" name="password" :placeholder="lang($t('Password'))"
                        autocomplete="off" @keyup.enter="fireLogin">
                </form>

                <div class="forgot-pw" @click="mpmsForgotPwPage">
                    <a>{{ lang($t('Forgot Password')) }}</a>
                </div>
                <div class="keep-login">
                    <input type="checkbox" name="layout" id="keep-login" value="option1" v-on:click="toggleSavePw">
                    <label class="pull-right text" for="keep-login">{{ lang($t('Keep Logged In')) }}</label>
                </div>
                <div class="clear"></div>
                <a class="btn-login" @click="fireLogin">{{ lang($t('Login')) }}</a>
            </div>
            <!--end box login-->

            <div class="break-line"><span>{{ lang($t('or')) }}</span></div>

            <!--box signup-->
            <a class="btn-signup" @click="mpmsSignUpPage">{{ lang($t('Sign Up')) }}</a>
            <!--end box signup-->
        </div>
        <div class="dark-mask" @click="close"></div>
    </div>
</template>

<script>
import Vue from 'vue';
import EventBus from '@common/eventBus';
import { common } from "@mixins/common";
import { storeMapper } from '@mixins/storeMapper';
import api from '@js/api';

export default {
    name: "LoginPopup",
    mixins: [common, storeMapper],
    data() {
        return {
            isShow: false,
            showErrorMsg: false,
            savePw: false
        }
    },
    methods: {
        show() {
            this.isShow = true;
        },
        close() {
            this.isShow = false;
        },
        toggleSavePw() {
            let self = this;
            if (this.savePw) {
                this.savePw = false;
                self.setAutoComplete("off");

            } else {
                this.savePw = true;
                self.setAutoComplete();

            }
        },
        fireLogin() {

            let self = this;
            var username = document.getElementById("username").value;
            var password = document.getElementById("password").value;

            if (!username || !password) {
                return;
            }

            EventBus.$emit("showGlobalLoading");
            api.userLogin(username, password).then(resp => {
                self.showErrorMsg = false;
                self.isShow = false;
                if (resp) {
                    if (resp.data.referrer_url) {
                        window.location.href = resp.data.referrer_url;
                        return;
                    }
                    access_token = resp.data.token.access_token;
                    display_name = resp.data.display_name;
                    member_avatar = resp.data.avatar;
                    member_role = resp.data.member_role;
                    membercode = resp.data.membercode;
                    is_demo_user = resp.data.is_demo_user;
                    is_demo_displayable = resp.data.is_demo_displayable

                    if (self.storeMainSite) {
                        var token = "";
                        if (access_token) {
                            token += "?access_token=" + access_token;
                        }
                        var url = "http://" + self.storeMainSite.relation + "." + window.urlData.domain;
                        this.$store.commit('mainSite/setRelationURL', url + token);
                    }

                }

                EventBus.$emit("checkLogin");
                EventBus.$emit("refreshModules"); //更新module - 取得sso links
                EventBus.$emit("refreshMenu"); //更新Menu - check user permission
                EventBus.$emit("refreshNews"); //更新news - 取得sso links
                EventBus.$emit("hideGlobalLoading");


            }).catch(function (resp) {
                self.showErrorMsg = true;
                EventBus.$emit("hideGlobalLoading");

            });
        },
        setAutoComplete(status = 'on') {
            jQuery("#loginForm").attr('autocomplete', status);
            jQuery("#username").attr('autocomplete', status);
            jQuery("#password").attr('autocomplete', status);
        },
        mpmsForgotPwPage() {
            window.location.href = mpms_forgot_pw_page;
        },
        mpmsSignUpPage() {
            window.location.href = mpms_sign_up_page;
        }
    }
}
</script>

<style scoped lang="scss">
@import "~@sass/_variables.scss";
@import "~@sass/_mixins.scss";

/*login popup*/
.login-popup {
    background-color: #fff;
    position: fixed;
    z-index: 1060;
    left: 50%;
    top: 50%;
    padding: 3rem 5rem;
    width: auto;
    -webkit-box-shadow: -2px -2px 12px 0px rgba(0, 0, 0, 0.1);
    -moz-box-shadow: -2px -2px 12px 0px rgba(0, 0, 0, 0.1);
    box-shadow: -2px -2px 12px 0px rgba(0, 0, 0, 0.1);
    -webkit-radius: 6px;
    -moz-border-radiust: 6px;
    border-radius: 6px;
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    -o-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
}

.login-popup .btn-close {
    display: block;
    width: 1.25rem;
    height: 1.25rem;
    position: absolute;
    right: 32px;
    top: 32px;
}

.login-popup .btn-close>div {
    width: 1.25rem;
    height: 1.25rem;
}

.login-popup .btn-close svg {
    fill: #afc0cb;
    -webkit-transition: all 0.2s ease-in-out;
    -moz-transition: all 0.2s ease-in-out;
    -o-transition: all 0.2s ease-in-out;
    transition: all 0.2s ease-in-out;
}

.login-popup .btn-close:hover svg {
    fill: #608197;
}

.login-popup h1 {
    font-size: 1.5rem;
    width: 100%;
    text-align: center;
    color: #608197;
    font-weight: 500;
    padding: 0 0 1.5rem 0;
    line-height: 1;
}

.login-popup p {
    text-align: center;
    padding-bottom: 1rem;
    line-height: 150%;
}

.login-popup p.txt-red {
    margin-top: -1rem;
}

.login-popup input[type=text],
.login-popup input[type=password] {
    font-size: 1rem;
    width: 100%;
    text-align: center;
    height: 3rem;
    line-height: 3rem;
    border: 1px solid #bfbfbf;
    background-color: #fff;
    margin-bottom: 1rem;
    -webkit-radius: 6px;
    -moz-border-radiust: 6px;
    border-radius: 6px;
}

.login-popup .btn-login,
.login-popup .btn-signup {
    text-transform: uppercase;
    height: 3rem;
    font-size: 1.25rem;
    padding: 0;
    text-align: center;
    line-height: 3rem;
    border: 0;
    width: 100%;
    display: block;
    -webkit-radius: 6px;
    -moz-border-radiust: 6px;
    border-radius: 6px;
    -webkit-transition: all 0.2s ease-in-out;
    -moz-transition: all 0.2s ease-in-out;
    -o-transition: all 0.2s ease-in-out;
    transition: all 0.2s ease-in-out;
}

.login-popup .btn-signup {
    background-color: #007ac6;
    color: #fff;
}

.login-popup .btn-login:hover {
    background-color: #efce5f;
}

.login-popup .btn-signup:hover {
    background-color: #006eb2;
}

.break-line {
    padding: 2rem 0;
    position: relative;
}

.break-line:before {
    content: '';
    height: 1px;
    position: absolute;
    top: 50%;
    left: 0;
    background-color: #c6c6c6;
    width: 100%;
    -webkit-transform: translateY(-1px);
    -moz-transform: translateY(-1px);
    -ms-transform: translateY(-1px);
    -o-transform: translateY(-1px);
    transform: translateY(-1px);
}

.break-line span {
    color: #a3a3a3;
    text-align: center;
    padding: 0 1rem;
    background-color: #fff;
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    -o-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
}

.box-login .forgot-pw,
.box-login .keep-login {
    margin: 0.5rem 0 2rem 0;
    font-size: 0.875rem;
}

.box-login .forgot-pw:hover a,
.box-login .keep-login:hover {
    text-decoration: underline;
}

.box-login .forgot-pw {
    float: left;
}

.box-login .forgot-pw:before {
    content: '';
    float: left;
    width: 1.25rem;
    height: 1.25rem;
    display: block;
    background: url(/img/forgot-pw.svg) no-repeat scroll left top;
    background-size: 100%;
}

.box-login .forgot-pw a {
    padding: 0 0 0 0.5rem;
    line-height: 1.25rem;
    display: inline-block;
}

.box-login .keep-login {
    float: right;
}

.box-login .keep-login label {
    font-size: 0.875rem;
    margin-right: 0;
    padding: 0 0 0 1.75rem;
    line-height: 1.25rem;
}

/*dark mask*/
.dark-mask {
    background-color: #1d3648;
    opacity: 0.7;
    width: 100vw;
    height: 100vh;
    z-index: 59;
    position: fixed;
    left: 0;
    top: 0;
}

@include narrow {
    .login-popup {
        padding: 1rem;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        overflow: auto;
        -webkit-radius: 0px;
        -moz-border-radiust: 0px;
        border-radius: 0px;
        -webkit-transform: translate(0%, 0%);
        -moz-transform: translate(0%, 0%);
        -ms-transform: translate(0%, 0%);
        -o-transform: translate(0%, 0%);
        transform: translate(0%, 0%);
    }

    .login-popup h1 {
        padding: 1rem 0 1.5rem 0;
    }

    .login-popup .btn-close {
        right: 1rem;
        top: 1rem;
    }
}

.clear {
    clear: both;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/LoginPopup.vue